module.exports = __webpack_public_path__ + "img/wheel-plate-min.e53d82c9.png";